import React, { useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import { ProfileHeader } from './ProfileHeader';
import { ProfileContent } from './ProfileContent';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { LoadingComponent } from '../../app/layout/LoadingComponent';

const ProfilePage: React.FC = observer(() => {
  const { username } = useParams<{ username: string }>();
  const { profileStore } = useStore();
  const { loadProfile, loadingProfile, profile, setActiveTab } = profileStore;

  useEffect(
    function loadProfilesOnMount() {
      if (username) loadProfile(username);

      const cleanup = function cleanup() {
        setActiveTab(0);
      };

      return cleanup;
    },
    [loadProfile, setActiveTab, username],
  );

  if (loadingProfile) return <LoadingComponent content="Loading profile..." />;

  return (
    <Grid>
      <Grid.Column width={16}>
        {profile && (
          <>
            <ProfileHeader profile={profile} />
            <ProfileContent profile={profile} />
          </>
        )}
      </Grid.Column>
    </Grid>
  );
});

export { ProfilePage };
